import React, { useEffect, useState, Suspense, lazy } from "react";
// external libraries
// import Particles from 'react-tsparticles';
// import { Main } from "tsparticles-engine";
//import Slide from 'react-reveal/Slide';
import Particles from "react-particles-js"
import Fade from 'react-reveal/Fade';
import MouseParticles from 'react-mouse-particles'

// Sections
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Portfolio from "./Components/Portfolio";
import Education from "./Components/Education";
import WorkExperience from './Components/WorkExperience';
import Skills from './Components/Skills';

// import particle config
//import particleConfig from "./particlesConfig.json"

import "./App.css";

const App = () => {
  // particles
  // const particlesInit = (main) => {
  //   console.log(main);
  // }
  // const particlesLoaded = (container) => {
  //   console.log(container);
  // };

  const [resumeData, setResumeData] = useState({});
  const [particlesData, setParticlesData] = useState({});

  // data loading
  useEffect(() => {
    fetch("/resumeData.json")
      .then((res) => res.json())
      .then((data) => {
        setResumeData(data);
      });
    fetch("/particlesConfig.json")
      .then((res) => res.json())
      .then((data) => {
        setParticlesData(data);
      });
  }, []);

  return (
    <div className="App">
      <MouseParticles g={1} color={["#ffffff", "#a8acce", "#dae3ef", "#ccd7cf"]} v={1} life={1} />
      <Particles className="App-particles__container" params={particlesData} />
      <Fade top>
        <Header data={resumeData.main} />
      </Fade>
      <Fade left>
        <About data={resumeData.main} />
      </Fade>
      <section id="resume">
        <Fade right><Education data={resumeData.resume} /></Fade>
        <Fade left><WorkExperience data={resumeData.resume} /></Fade>
        {/* <Fade right><Skills data={resumeData.resume} /></Fade> */}
      </section>
      {/* <Fade left>
        <Portfolio data={resumeData.portfolio} />
      </Fade> */}
      {//<Testimonials data={resumeData.testimonials} />
      }
      <Fade right>
        <Contact data={resumeData.main} />
      </Fade>
      <Fade bottom>
        <Footer />
      </Fade>
    </div>
  );
};

// TODO: https://www.npmjs.com/package/react-parallax add parallax effect to banner

export default App;
